import React, { Component } from 'react';
import Alert from 'react-s-alert';
import ItemConteudo from './ItemConteudo';
import Loading from '../../Loading';
import ModalBase from '../../ModalBase';
import ModalAddEstudo from '../../coordenador/ModalAddEstudo';
import ModalDetalheConteudo from '../../coordenador/ModalDetalheConteudo';
import EdbButton from '../../EdbButton';
import SelecionarEscola from '../../coordenador/SelecionarEscola';

import * as BibliotecaRequest from '../../../requests/biblioteca.request';
import * as TrilhaRequest from '../../../requests/trilha.request';
import { Subscribe } from 'unstated'
import UserContainer from '../../../containers/user.container'
import { PracticeTestContainer } from '../../../containers/practiceTest.container'

class BibliotecaConteudo extends Component {

    searchFilter = null
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showModalDetalhes: false,
            showModalConfirmacao: false,
            showModalAddEstudo: false,
            showModalEstudo: false,
            loadingBtnMaisTarde: false,
            loadingBtnIniciarEstudo: false,
            pesquisou: false,
            tagSuggestions: [],
            conteudos: [],
            activePage: 1,
            itemsCountPerPage: 12, //Deve ser sempre um número par
            conteudoAtualIdx: undefined,
            conteudoAtualId: undefined,
            loadingFinalizarModal: false

        }
        this.studiesChecked = [];
        this.conteudosModal = [];
        this.hasSelected = false;
        this.studyDetails = {};

        this.onChangeSearchFilterTags = this.onChangeSearchFilterTags.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.mostrarMais = this.mostrarMais.bind(this);
        this.onCloseModalDetalhes = this.onCloseModalDetalhes.bind(this);
        this.onClickAddConteudoDetalhes = this.onClickAddConteudoDetalhes.bind(this);
        this.onClickModalCancel = this.onClickModalCancel.bind(this);
        this.onClickModalMaisTarde = this.onClickModalMaisTarde.bind(this);
        //this.onClickModalIniciarEstudo = this.onClickModalIniciarEstudo.bind(this);
        this.selectStudy = this.selectStudy.bind(this);
        this.onCloseModalAddEstudo = this.onCloseModalAddEstudo.bind(this);
        this.onClickAddEstudo = this.onClickAddEstudo.bind(this);
        this.onChangeSearchInput = this.onChangeSearchInput.bind(this);
        this.closeModalEstudo = this.closeModalEstudo.bind(this);
        this.onClickConteudo = this.onClickConteudo.bind(this);
        this.onClickStudent = this.onClickStudent.bind(this);
        this.onChangeSelectedSchool = this.onChangeSelectedSchool.bind(this)

    }

    async componentDidMount() {
        await this.props.userContainer.getSchools();

        // define a escola atual
        this.props.practiceTestContainer.setState({ selectedSchool: this.props.userContainer.state.selectedSchool });
        this.props.practiceTestContainer.setInitialState(this.props.userContainer.state.selectedSchool);
        this.conteudosModal = [];

    }

    async selectStudy(id) {
        // adiciona estudos para inclusão
        // var index = this.studiesChecked.indexOf(~~item);
        // if(isChecked && index === -1) this.studiesChecked.push(~~item)
        // if(!isChecked && index > -1)  this.studiesChecked.splice(index, 1);

        // carrega os detalhes do estudo
        await this.loadStudyDetails(~~id);

        // abre modal de adicionar estudos
        this.onClickAddConteudoDetalhes(id);
    }

    onChangeSelectedSchool(school) {
        this.props.userContainer.setState({ selectedSchool: school, selectedGrade: {}, classes: [] })
        this.props.practiceTestContainer.setState({ selectedSchool: school });
        this.props.practiceTestContainer.setInitialState(school);
    }

    onChangeSearchFilterTags() {
        this.setState({ loading: true });

        setTimeout(() => this.setState({ loading: false }), 3000);
    }

    onPageChange(pageNumber) {
        // console.log(`active page is ${pageNumber}`);
        this.setState({ activePage: pageNumber });

        // this.setState({ activePage: pageNumber, loading: true });
        // setTimeout(() => this.setState({ loading: false }), 3000);
    }

    mostrarMais() {
        this.setState({ activePage: this.state.activePage + 1 });
    }

    // getDescricaoTipo(tipo) {
    //     if (tipo === 'livro') return 'páginas';
    //     if (tipo === 'video') return 'minutos';
    //     if (tipo === 'questoes') return 'questões';
    // }
    // getTipoConteudo(tipo) {
    //     if (tipo === 'livro') return 'MATERIAL DIDÁTICO';
    //     if (tipo === 'video') return 'VIDEO';
    //     if (tipo === 'questoes') return 'ATIVIDADE';
    //     if (tipo === 'externo') return 'EXTERNO';
    // }

    getConteudosPaginados() {
        var pagina = this.state.activePage - 1;
        var total = this.state.conteudos.length;
        var qtdPorPagina = this.state.itemsCountPerPage;

        var resultadoPaginado = this.state.conteudos.slice(pagina * qtdPorPagina, Math.min((pagina * qtdPorPagina) + qtdPorPagina, total));
        return resultadoPaginado;
    }

    getConteudosMostrarMais() {
        var pagina = this.state.activePage;
        var total = this.state.conteudos.length;
        var qtdPorPagina = this.state.itemsCountPerPage;

        var resultadoPaginado = this.state.conteudos.slice(0, Math.min(pagina * qtdPorPagina, total));
        return resultadoPaginado;
    }

    onCloseModalDetalhes() {
        this.setState({ showModalDetalhes: false, conteudoAtualIdx: undefined });
    }

    onClickAddConteudoDetalhes(id) {
        this.conteudosModal = this.state.conteudos.filter(item => item.id === ~~id);
        this.hasSelected = true;

        this.props.practiceTestContainer.setState({
            treeViewAlunosEstudo: { ...this.props.practiceTestContainer.state.treeViewAlunosEstudo, checked: [] },
             study: {...this.props.practiceTestContainer.state.study, dtStartStudy: new Date(), dtEndStudy: new Date(), inHasSummary: false } })

        this.setState({ showModalAddEstudo: true, conteudoAtualIdx: undefined, conteudoAtualId: undefined, showModalDetalhes: false });
    }

    async loadStudyDetails(id) {
        await this.props.practiceTestContainer.setState({ selectedStudy: id, study: {...this.props.practiceTestContainer.state.study, idStudy: [id] } })
        let study = await this.props.practiceTestContainer.getStudyDetails()
        study.idStudy = id;
        this.studyDetails = study;
    }

    async onClickConteudo(item) {
        await this.loadStudyDetails(item);

        this.setState({ showModalDetalhes: true });
    }


    onClickStudent(item, index) {

        if (this.props.isCoordenador || this.props.isProfessor) {
            this.setState({ showModalDetalhes: true, conteudoAtualIdx: index, conteudoAtualId: item.id });
        } else {
            this.setState({ showModalConfirmacao: true, conteudoAtualIdx: index, conteudoAtualId: item.id });
        }
    }

    onClickModalCancel() {
        if (this.state.loadingBtnMaisTarde || this.state.loadingBtnIniciarEstudo) { return; }

        this.setState({ showModalConfirmacao: false, conteudoAtualIdx: undefined });
    }

    async onClickModalMaisTarde() {

        if (this.state.loadingBtnIniciarEstudo) { return; }

        this.setState({ loadingBtnMaisTarde: true });

        var resultado = await this.addEstudo();

        this.setState({ showModalConfirmacao: false, loadingBtnMaisTarde: false });

        if (resultado) {
            Alert.success("Estudo adicionado com sucesso. Abra sua 'Trilha do Conhecimento' para visualiza-lo", { position: 'bottom-right' });
        }
    }

    // async onClickModalIniciarEstudo() {
    //     try {
    //         if (this.state.loadingBtnMaisTarde) { return; }

    //         this.setState({ loadingBtnIniciarEstudo: true });

    //         var resultado = await this.addEstudo();
    //         this.setState({ showModalConfirmacao: false, loadingBtnIniciarEstudo: false });

    //         if (resultado) {

    //             this.setState({ showModalEstudo: true });
    //         }
    //     }
    //     catch (e) {
    //         console.error(e);
    //         Alert.error("Não foi possivel iniciar o estudo. Tente novamente mais tarde.", { position: 'bottom-right' });
    //     }
    // }

    async addEstudo() {
        try {
            //Buscando o período atual
            var periodoAtual = await this.getAlunoPeriodPracticeTestAtual();
            var estudo = this.state.conteudos[this.state.conteudoAtualIdx];
            if (!estudo) {
                throw new Error("Não há estudo com idx: " + this.state.conteudoAtualIdx);
            }

            //Adicionando o conteúdo
            var response = await TrilhaRequest.setAddEstudoAluno(estudo.id, periodoAtual.idPeriodPracticeTest);

            //Tratando os retornos
            if (response.toString() === "1") {
                Alert.warning("Você ja tinha adicionado este estudo. Abra sua 'Trilha do Conhecimento' para visualiza-lo.", { position: 'bottom-right' });
                return false;
            }
            else if (response.toString() === "-1") {
                Alert.warning("Você já atingiu o limite máximo de estudos adicionados.", { position: 'bottom-right' });
                return false;
            }
            else if (response.toString() === "0") {
                throw new Error("Erro ao adicionar estudo. Response:" + response);
            }
            return true;
        }
        catch (e) {
            console.error(e);
            Alert.error("Não foi possivel adicionar o estudo. Tente novamente mais tarde.", { position: 'bottom-right' });
            return false;
        }
    }

    async getAlunoPeriodPracticeTestAtual() {
        try {
            var periodos = await TrilhaRequest.getTrilha();
            var periodoAtual = (periodos || []).find(item => !!item.inActivePeriodPracticeTest);

            if (!periodoAtual) {
                throw new Error("Não há nenhum período marcado como atual.")
            }

            return periodoAtual;
        }
        catch (e) {
            console.error(e);
            Alert.error("Não foi possivel obter o período atual do aluno. Tente novamente mais tarde.", { position: 'bottom-right' });
        }
    }

    closeModalEstudo() {
        this.setState({ showModalEstudo: false, conteudoAtualIdx: undefined, conteudoAtualId: undefined });
    }

    async onCloseModalAddEstudo() {
        this.setState({ showModalAddEstudo: false });
    }

    async onClickAddEstudo(finishLoading) {
        if(finishLoading) {
            this.setState({ loadingFinalizarModal: true })
        }
        const studyCreated = await this.props.practiceTestContainer.saveStudy()
        // console.log('study studyCreated studyCreated', studyCreated)
        if (studyCreated) Alert.info(studyCreated)
        this.setState({ showModalAddEstudo: false, loadingFinalizarModal: false });
    }

    onChangeSearchInput(termoSearch) {
        //Lógica de debounce, para buscar automaticamente após 700ms que parou de digitar
        var debounceId = window['bibliotecaSearchInputDebounce'];
        if (debounceId) {
            clearTimeout(debounceId);
        }
        window['bibliotecaSearchInputDebounce'] = setTimeout(() => this.pesquisarConteudos(termoSearch), 700);
    }

    async pesquisarConteudos(termoSearch) {

        try {

            this.setState({ pesquisou: !!termoSearch });

            if (!termoSearch) {
                this.setState({ loading: false, conteudos: [] });
                return;
            }

            this.setState({ loading: true });

            var response = await BibliotecaRequest.getConteudosSearch(termoSearch);
            var conteudos = (response || []).map(item => ({
                id: item.idStudy,
                img: this.getUrlTumbnail(item.obUrlThumbnail, 192, 144),
                titulo: item.txStudy,
                porcentagem: 0,
                tipo: item.txStudyTypeAbr,
                descricaoTipo: item.txStudyType,
                detalhes: item.txStudyDetails,
                disciplina: this.getDisciplines(item)[0].txDiscipline,
                status: item.inStatusStudy
                // dataLimite: moment(item.dtEndStudy).format("DD/MM/YYYY")
                // qtd: 5,
                // pontos: 150,
                // dia: 28,
                // diaSemana: 'SAB',
            }));

            // console.log('content ', conteudos)
            // console.log('content ',JSON.stringify(conteudos))

            this.studiesChecked = [];
            this.setState({ loading: false, conteudos: conteudos });
        }
        catch (e) {
            this.setState({ loading: false });
            console.error(e);
            Alert.error("Não foi possivel buscar os conteúdos. Tente novamente mais tarde.", { position: 'bottom-right' });
        }
    }

    getDisciplines(itemAPI) {
        //A api está retornando as disciplinas como uma string contendo um array json, por isso está sendo feita a conversão abaixo se necessário
        var disciplines = [];
        if (!Array.isArray(itemAPI.disciplines)) {
            try {
                disciplines = JSON.parse(itemAPI.disciplines);
            } catch (error) {
                console.error(error)
            }
        } else {
            disciplines = itemAPI.disciplines || [];
        }
        return disciplines;
    }

    getUrlTumbnail(uri, w, h) {
        return `${process.env.REACT_APP_IMAGES}/${w}x${h}/smart${uri}`;
    }

    getEmptyNovoEstudoAluno() {
        return <div className="edb-container" style={{ maxWidth: '960px', margin: '0 auto' }}>
            <div className="edb-container edb-third"><img alt="Pesquisar biblioteca de conteúdo" src="images/emptystates/search.svg" width="100%" /></div>
            <div className="edb-container edb-twothird">
                <div className="edb-col"><h1>Vamos estudar algo novo?</h1></div>
                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>1</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small ">Procure o estudo</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Procure o estudo</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Primeiro você busca as disciplinas, os conteúdos ou as palavras-chave que está querendo estudar.</p>
                    </div>
                </div>

                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>2</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small ">Adicione à sua trilha</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Adicione à sua trilha</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Adicione o estudo que escolheu à sua Trilha do Conhecimento.</p>
                    </div>
                </div>

                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>3</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small ">Agora é só estudar</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Agora é só estudar</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Pronto! Em qualquer uma das trilhas seus estudos aparecerão numa seção exclusiva: "Para você virar o bicho!"</p>
                    </div>
                </div>
            </div>
        </div>
    }

    getEmptyNovoEstudo() {
        return <div className="edb-container" style={{ maxWidth: '960px', margin: '0 auto' }}>
            <div className="edb-container edb-third"><img alt="Pesquisar biblioteca de conteúdo" src="images/emptystates/search.svg" width="100%" /></div>
            <div className="edb-container edb-twothird">
                <div className="edb-col"><h1>Distribuir estudos aos alunos</h1></div>
                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>1</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small ">Procure os estudos</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Procure os estudos</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Primeiro você busca as disciplinas, os conteúdos ou as palavras-chave para filtrar os estudos.</p>
                    </div>
                </div>

                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>2</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small ">Selecione os estudos</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Selecione os estudos</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Selecione um ou mais estudos que deseja distribuir.</p>
                    </div>
                </div>

                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>3</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small ">Criar estudo</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Criar estudo</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Clique no botão criar estudo para definir quando e para quem serão distribuídos os estudos selecionados.</p>
                    </div>
                </div>
            </div>
        </div>
    }

    render() {
        return (<div>


            {(this.props.isCoordenador || this.props.isProfessor) && <div className="edb-row edb-padding-top edb-padding-left">
                <div className="edb-col l8 edb-margin-bottom ">
                    <SelecionarEscola
                        escolas={this.props.userContainer.state.schools}
                        onChange={this.onChangeSelectedSchool}
                    />
                </div>
            </div>}

            <div className="edb-row edb-margin-top edb-padding-small">
                <div className="edb-col l1">&nbsp;</div>
                <div className="edb-col l10">
                    {/* Lista de tags de filtro */}
                    {/* <div className="edb-margin-small-bottom">
                        Filtrar por tipo:
                        {this.state.tagSuggestions.map((item, idx) =>
                            <div className="edb-small adap-medium-gray edb-tag edb-round edb-padding-small edb-margin-small-left" key={'tag-'+idx}
                                onClick={() => this.searchFilter.addTagsIfNotExist([item])}>{item.name}</div>
                        )}
                    </div> */}

                    {/* <SearchFilter
                        ref={ref => this.searchFilter = ref}
                        suggestions={this.state.tagSuggestions}
                        onChangeTags={this.onChangeSearchFilterTags} /> */}

                    {/* Busca por campo de texto */}
                    <div className="adap-input-icon-container ">
                        <i className="adap-input-icon fas fa-search"></i>
                        <input className="adap-input" placeholder="Pesquise disciplina, conteúdo ou palavras-chave..." onChange={(ev) => this.onChangeSearchInput(ev.target.value)} />
                    </div>
                </div>

            </div>

            {this.state.loading && <Loading />}

            {!this.state.loading && <div>

                {this.state.pesquisou && this.state.conteudos.length === 0 && <div className="edb-center edb-margin-large-top">
                    <h3>Nenhum conteúdo encontrado</h3>
                    <div>Tente pesquisar com outro termo.</div>
                </div>}

                {!this.state.pesquisou && (!this.props.isCoordenador && !this.props.isProfessor) && this.state.conteudos.length === 0 && this.getEmptyNovoEstudoAluno()}

                {!this.state.pesquisou && (this.props.isCoordenador || this.props.isProfessor) && this.state.conteudos.length === 0 && this.getEmptyNovoEstudo()}

                {this.state.conteudos.length > 0 && <div className="edb-margin-large-top">

                    <ModalBase style={{ width: "420px" }} isOpen={this.state.showModalConfirmacao} hideClose={true} content={
                        <div className="edb-padding-large">
                            {/* <h3>Deseja iniciar este conteúdo agora?</h3> */}
                            <h3>Deseja adicionar este estudo na sua 'Trilha do Conhecimento'?</h3>
                            <div className="edb-row edb-margin-large-top">
                                <div className="edb-col s6 edb-padding-right">
                                    <button
                                        className="edb-block-mobile edb-margin-bottom  edb-button adap-gray edb-round  edb-block"
                                        onClick={this.onClickModalCancel}>
                                        Não
                                    </button>
                                </div>
                                <div className="edb-col s6">
                                    <EdbButton className="edb-block-mobile edb-margin-bottom edb-margin-right adap-gray edb-block"
                                        content="Sim, adicionar"
                                        loading={this.state.loadingBtnMaisTarde}
                                        loadingContent="Adicionando..."
                                        onClick={this.onClickModalMaisTarde}
                                    />
                                </div>

 


                                {/* <EdbButton className="edb-block-mobile edb-margin-bottom edb-margin-right adap-gray edb-block"
                                    content="Sim, iniciar estudo"
                                    loading={this.state.loadingBtnIniciarEstudo}
                                    loadingContent="Iniciando..."
                                    onClick={this.onClickModalIniciarEstudo}
                                /> */}

                            </div>
                        </div>
                    } />
                    {(this.props.isCoordenador || this.props.isProfessor) && this.state.showModalDetalhes && <ModalDetalheConteudo
                        study={this.studyDetails}
                        isOpen={this.state.showModalDetalhes}
                        onClickAddConteudo={this.onClickAddConteudoDetalhes}
                        onCloseModal={this.onCloseModalDetalhes} />}

                    {this.hasSelected && <ModalAddEstudo
                        id={this.studyDetails.idStudy}
                        study={this.studyDetails}
                        conteudos={this.conteudosModal}
                        isOpen={this.state.showModalAddEstudo}
                        onCloseModal={this.onCloseModalAddEstudo}
                        onClickAddConteudo={this.onClickAddEstudo}
                        userContainer={this.props.userContainer}
                        loadingFinalizar={this.state.loadingFinalizarModal}
                        practiceContainer={this.props.practiceTestContainer}
                    />}

                    {/* {this.isUserStudent && <ModalDetalheConteudo isOpen={this.state.showModalDetalhes} onCloseModal={this.onCloseModalDetalhes} onClickAddConteudo={this.onClickAddConteudo} />} */}


                    {/* {this.state.showModalEstudo && <ModalEstudo isOpen={this.state.showModalEstudo} onCloseModal={this.closeModalEstudo} idEstudo={this.state.conteudoAtualId} />} */}

                    {/********************* Conteúdos **********************/}
                    <div>
                        {this.getConteudosMostrarMais().map((item, index) =>
                            // <ItesmConteudo key={`adap-biblioteca-item-${index}`} {...item} onClick={() => this.onClickConteudo(item, index)} />
                            <ItemConteudo key={`adap-biblioteca-item-${index}`} {...item} selectStudy={this.selectStudy} isStudent={!this.props.isCoordenador && !this.props.isProfessor} onClickStudent={() => this.onClickStudent(item, index)} onClick={this.onClickConteudo} />
                        )}
                    </div>

                    <div className="edb-center">
                        {this.getConteudosMostrarMais().length < this.state.conteudos.length &&
                            <button className="edb-button adap-gray edb-margin" onClick={this.mostrarMais}>+ Exibir mais resultados</button>
                        }
                    </div>

                    {/********************* Conteúdos (Dektop com paginação) **********************/}
                    {/* <div className="edb-hide-small edb-hide-medium" style={{ display: "flex", flexWrap: "wrap" }}>
                        {this.getConteudosPaginados().map((item, index) =>
                            <div key={`card-adap-estudos-${index}`} className="edb-padding-small edb-margin-bottom" style={{ flex: `0 0 ${100 / (this.state.itemsCountPerPage / 2)}%` }} >
                                <div className="adap-medium-gray edb-small edb-center">{this.getTipoConteudo(item.tipo)}</div>
                                <div className=" adap-light-gray">
                                    <img src={item.img} alt={item.titulo} width="100%" />
                                </div>
                                <div className="edb-padding-small">
                                    <div className="edb-row">
                                        <div className="edb-col s8">{item.disciplina}</div>
                                        <div className="edb-col s4 edb-right-align adap-text-green">
                                            {item.porcentagem > 0 && item.porcentagem < 100 && <span> <i className="far fa-dot-circle"></i> {item.porcentagem}%</span>}
                                            {item.porcentagem === 100 && <span><i className="far fa-check-circle"></i> {item.porcentagem}%</span>}
                                        </div>
                                    </div>
                                    <div className="edb-text-bold">{ClampText(item.titulo, 60)}</div>
                                    <div className="edb-small"><span className="edb-text-bold">{item.qtd}</span> {this.getDescricaoTipo(item.tipo)}, <span className="edb-text-bold">{item.pontos}</span> pontos</div>
                                    {item.dataLimite && <div className="edb-small">Limite <b>{item.dataLimite}</b></div>}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="edb-hide-small edb-hide-medium edb-center">
                        {this.state.itemsCountPerPage < this.state.conteudos.length &&
                            <Pagination
                                activePage={this.state.activePage}
                                totalItemsCount={this.state.conteudos.length}
                                itemsCountPerPage={this.state.itemsCountPerPage}
                                onChange={this.onPageChange}
                                innerClass="edb-bar edb-round edb-white edb-padding-none adap-text-darkergray"
                                itemClass="edb-button edb-text-bold"
                                activeClass="adap-blue"
                                prevPageText={<i className="fas fa-angle-left "></i>}
                                nextPageText={<i className="fas fa-angle-right"></i>}
                                firstPageText={<i className="fas fa-angle-double-left"></i>}
                                lastPageText={<i className="fas fa-angle-double-right"></i>}
                            />
                        }
                    </div> */}
                </div>}
            </div>}
        </div>);
    }
}

// export default BibliotecaConteudo;

export default (props) => (<Subscribe to={[UserContainer, PracticeTestContainer]}>
    {(user, estudo) => <BibliotecaConteudo {...props} userContainer={user} practiceTestContainer={estudo} />}
</Subscribe>);
